<app-add-name [parentComp]="'guest'" (save)="onSave($event)" (cancelEvent)="onCancel()"></app-add-name>